import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Api_Url } from "../../../config/config";
import axios from "axios";
import { Button, Modal, Table } from "antd";
import "./BuisnessPd.css";
import { ArrowLeftOutlined } from '@ant-design/icons';

function BuisnessPdEmployeeDetails() {
  const location = useLocation();
  const { state } = location;
  const customerName = state?.record?.name;
  const { id } = useParams();
  const [singleData, setSingleData] = useState([]);
  const [incomesData, setIncomesData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const nav = useNavigate();


  const BuisnessPdSingleUserDetailsfunction = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/BusinessPd/getprofilesbybusinesspdid/${id}`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setSingleData(response.data);
    } catch (error) {
      console.error(error.message);
    }
  };

  const [data, setData] = useState([])

  useEffect(()=>{

    const adata=(incomesData.map((item)=>{
        return item.shop
    }))
    setData(adata)
  },[])

// console.log(data.map((item)=>console.log(item)))

// console.log(data.map((item)=>console.log(item.name)))

  


  useEffect(() => {
    BuisnessPdSingleUserDetailsfunction();
  }, []);

//   console.log(singleData);

  const navigate = useNavigate();

  const columns = [
    {
      title: "Name",
      dataIndex: "Name",
      render: (text, record) => (
        <span className="table-avatar">
          <span className="avatar">
            <img alt="" src={record.profileImageUrl} />
          </span>
          <span>
            {record.profileName} {record.name}
          </span>
        </span>
      ),
    },
    {
      title: "Customer Name",
      dataIndex: "Name",
      render: () => <span>{customerName}</span>,
    },
    {
      title: "Gross Monthly Income",
      dataIndex: "income",
      render: (text, record) => (
        <span>{record?.income?.grossMonthlyIncome}</span>
      ),
    },
    {
      title: "Net Monthly Income",
      dataIndex: "income",
      render: (text, record) => <span>{record?.income?.netMonthlyIncome}</span>,
    },
    {
      title: "Total Expenses",
      dataIndex: "status",
      render: (text, record) => <span>{record?.income?.totalExpenses}</span>,
    },
    // {
    //     title: 'Profit Margin Name',
    //     dataIndex: 'income',
    //     render: (text, record) => (
    //         <span>{record?.profitMargin?.name}</span>
    //     ),
    // },
    // {
    //     title: 'Maximum Profit',
    //     dataIndex: 'income',
    //     render: (text, record) => (
    //         <span>{record?.profitMargin?.maximizeProfit}</span>
    //     ),
    // },
    // {
    //     title: 'Minimum Profit',
    //     dataIndex: 'income',
    //     render: (text, record) => (
    //         <span>{record?.profitMargin?.minimumProfit}</span>
    //     ),
    // },
    // {
    //     title: 'Remark',
    //     dataIndex: 'income',
    //     render: (text, record) => (
    //         <span>{record?.remark}</span>
    //     ),
    // },
    // {
    //     title: 'Status',
    //     dataIndex: 'income',
    //     render: (text, record) => (
    //         <span>{record?.status}</span>
    //     ),
    // },
    {
      title: "View",
      dataIndex: "actions",
      render: (text, record) => (
        <Button
          className="btn-property"
          onClick={() => {
            navigate(`allinfodetails/${record.id}`, {
              state: { ...record },
            });
          }}>
          <i className="fa-solid fa-eye"></i>
        </Button>
      ),
    },
  ];

  // const handleViewClick = async (record) => {
  //   console.log(record.incomes);
  //   setIncomesData(record.incomes)
  //   setIsModalVisible(true)
  // };

  const rowClassName = (record) => {
    return record.isMismatched ? "table-row-red" : "";
  };


  const handleBackButton = ()=>{
    nav(-1)
  }



  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
      <Button type="primary" icon={<ArrowLeftOutlined />} className="mb-3" onClick={handleBackButton}>
      Back
    </Button>
        <div className="row">
          <div className="col-md-12">
            <div className="table-responsive">
              <Table
                className="table-striped"
                style={{ overflowX: "auto" }}
                columns={columns}
                dataSource={singleData}
                rowKey={(record) => record.id}
                rowClassName={rowClassName}
              />
            </div>
          </div>
        </div>

        {/* <Modal
          title="Activity Details"
          visible={isModalVisible}
          onCancel={() => setIsModalVisible(false)}
          footer={null}
          className="custom-modal" // Add custom class for additional styling if needed
        >
          <div className="container">
            <div className="row">
              {data.map((item) => {
                return (

                )
              })}
            </div>
          </div>
        </Modal> */}
      </div>
    </div>
  );
}

export default BuisnessPdEmployeeDetails;

// import React, { useEffect, useState } from 'react';
// import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
// import { Api_Url } from '../../../config/config';
// import axios from 'axios';
// import Breadcrumbs from '../../../components/Breadcrumbs';
// import BuisnessPDFilter from './BuisnessPDFilter';
// import { Button, Table } from 'antd';
// import './BuisnessPd.css';
// import { render } from '@testing-library/react';

// function BuisnessPdEmployeeDetails() {
// const location = useLocation()

// const {state} = location

// const customerName = state?.record?.name

//     const { id } = useParams();
//     const [singleData, setSingleData] = useState([]);

//     const BuisnessPdSingleUserDetailsfunction = async () => {
//         try {
//             const response = await axios.get(`${Api_Url}api/v1/BusinessPd/getprofilesbybusinesspdid/${id}`, {
//                 headers: {
//                     Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//                 },
//             });
//             console.log('Data', response.data);
//             setSingleData(response.data);
//         } catch (error) {
//             return error.message;
//         }
//     };

//     useEffect(() => {
//         BuisnessPdSingleUserDetailsfunction();
//     }, []);
// const navigate = useNavigate();

//     const columns = [
//         {
//             title: 'Name',
//             dataIndex: 'Name',
//             render: (text, record) => (
//                 <span className="table-avatar">
//                     <span className="avatar">
//                         <img alt="" src={record.profileImageUrl} />
//                     </span>
//                     <span>{record.profileName} {record.name}</span>
//                 </span>
//             ),
//         },
//         {
//             title: 'Name',
//             dataIndex: 'Name',
//             render: (text, record) => (
//                 <span>{customerName}</span>
//             ),
//         },
//         {
//             title: 'Gross Monthly Income',
//             dataIndex: 'customerName',
//             render: (text, record) => (
//                 <span>{record?.income?.grossMonthlyIncome}</span>
//             )
//         },
//         {
//             title: 'Net Monthly Income',
//             dataIndex: 'income',
//             render: (text, record) => (
//                 <span>{record?.income?.netMonthlyIncome}</span>
//             )
//         },
//         {
//             title: 'Total Expenses',
//             dataIndex: 'status',
//             render: (text, record) => (
//                 <span>{record?.income?.totalExpenses}</span>
//             )
//         },
//         {
//             title: "View",
//             dataIndex: "actions",
//             render: (text, record) => (
//               <Button className="btn-property"
//                 onClick={() => {
//                   navigate(`allinfodetails/${record.id}`, {
//                     state: { record },
//                   });
//                 }}>
//                   <i className="fa-solid fa-eye"></i>
//                   </Button>
//             ),
//           },
//     ];

//     const rowClassName = (record) => {
//         return record.isMismatched ? 'table-row-red' : '';
//     };

//     return (
//         <>
//             <div className="page-wrapper">
//                 <div className="content container-fluid">
//                     {/* <Breadcrumbs
//                         maintitle="PD"
//                         title="Credit"
//                         subtitle="Business PD"
//                         modal="#add_client"
//                         name="Add Business PD"
//                         Linkname="/clients"
//                         Linkname1="/clients-list"
//                         addModalLink="add"
//                     /> */}

//                     {/* <BuisnessPDFilter /> */}
//                     <div className="row">
//                         <div className="col-md-12">
//                             <div className="table-responsive">
//                                 <Table
//                                     className="table-striped"
//                                     style={{ overflowX: 'auto' }}
//                                     columns={columns}
//                                     dataSource={singleData}
//                                     rowKey={(record) => record.id}
//                                     rowClassName={rowClassName}
//                                 />
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// }

// export default BuisnessPdEmployeeDetails;

// import React, { useEffect, useState } from 'react'
// import { Link, useParams } from 'react-router-dom'
// import { Api_Url } from '../../../config/config'
// import axios from 'axios'
// import Breadcrumbs from '../../../components/Breadcrumbs'
// import SearchBox from '../../../components/SearchBox'
// import BuisnessPDFilter from './BuisnessPDFilter'
// import { Table } from 'antd'
// import { Columns } from 'react-feather'

// function BuisnessPdEmployeeDetails() {

//     const { id } = useParams()

//     const [singleData, setSingleData] = useState([])

//     const BuisnessPdSingleUserDetailsfunction = async () => {
//         try {
//             const response = await axios.get(`${Api_Url}api/v1/BusinessPd/getprofilesbybusinesspdid/${id}`, {
//                 headers: {
//                     Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//                 }
//             })
//             console.log("Data", response.data)
//             setSingleData(response.data)
//         } catch (error) {
//             return error.message
//         }
//     }

//     useEffect(() => {
//         BuisnessPdSingleUserDetailsfunction()
//     }, [])

//     const columns = [
//         {
//           title: "Name",
//           dataIndex: "Name",
//           render: (text, record) => (
//             <span className="table-avatar">
//               <Link className="avatar">
//                 <img alt="" src={record.profileImageUrl} />
//               </Link>
//               <Link>{record.profileName} ({record.branchName})</Link>
//             </span>
//           ),
//           sorter: (a, b) => a.Name.length - b.Name.length,
//         },
//         {
//           title: "Customer Name",
//           dataIndex: "customerName",
//           sorter: (a, b) => a.ClientId.length - b.ClientId.length,
//         },

//         {
//           title: "Income",
//           dataIndex: "income",
//           sorter: (a, b) => a.ContactPerson.length - b.ContactPerson.length,
//         },
//         {
//             title: "Status",
//             dataIndex: "status",
//             sorter: (a, b) => a.ContactPerson.length - b.ContactPerson.length,
//           },
//       ];

//     return (
//         <>
//             <div className="page-wrapper">
//         <div className="content container-fluid">

//           <Breadcrumbs
//             maintitle="PD"
//             title="Credit"
//             subtitle="Business PD"
//             modal="#add_client"
//             name="Add Business PD"
//             Linkname="/clients"
//             Linkname1="/clients-list"
//             addModalLink="add"
//           />

//           <BuisnessPDFilter />
//           <div className="row">
//             <div className="col-md-12">
//               <div className="table-responsive">
//                 {/* <SearchBox /> */}
//                 <Table
//                   className="table-striped"
//                   style={{ overflowX: "auto" }}
//                   columns={columns}
//                   dataSource={singleData}
//                   rowKey={(record) => record.id}
//                 />
//                 {/* <div className="container">
//                   <div className="row">
//                     {data && data.map((item) => {
//                       return (
//                         <>
//                           <div className='col-md-12'>
//                             <Link to={`details/${item.id}`}>
//                               <div className="card" style={{ backgroundColor: item.isIncomeMismatch ? '#f8d7da' : '' }}>
//                                 <div className="card-body">
//                                   <h5 className="card-title">Customer Name: <span>{item?.customerName}</span></h5>
//                                   <h5 className="card-title">Branch Name: <span>{item?.branchName}</span></h5>
//                                   <h5 className="card-title">Mobile: <span>{item?.mobile}</span></h5>
//                                   <h5 className="card-title">Annual Income: <span>{item?.income}</span></h5>
//                                   <h5 className="card-title">Login Date: <span>{item?.created}</span></h5>
//                                   <h5 className="card-title">Status: <span>{item?.status}</span></h5>
//                                 </div>
//                               </div>
//                             </Link>
//                           </div>
//                         </>
//                       )
//                     })}
//                   </div>
//                 </div> */}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//         </>
//     )
// }

// export default BuisnessPdEmployeeDetails
